import bookingRepo from '../services/bookings';
import notifier from '../services/notifier'

export const BOOKINGS_REFRESHED                   = 'BOOKINGS_REFRESHED';
export const BOOKING_UPDATED                      = 'BOOKING_UPDATED';
export const SHOW_BOOKING_DETAILS                 = 'SHOW_BOOKING_DETAILS';
export const HIDE_BOOKING_DETAILS                 = 'HIDE_BOOKING_DETAILS';
export const FILTER_BOOKINGS_BY_REFERENCE         = 'FILTER_BOOKINGS_BY_REFERENCE';
export const SHOW_DELETE_BOOKING_OVERLAY          = 'SHOW_DELETE_BOOKING_OVERLAY';
export const SHOW_ENROLL_USER_OVERLAY             = 'SHOW_ENROLL_USER_OVERLAY';
export const HIDE_DELETE_BOOKING_OVERLAY          = 'HIDE_DELETE_BOOKING_OVERLAY';
export const HIDE_ENROLL_USER_OVERLAY             = 'HIDE_ENROLL_USER_OVERLAY';
export const TOGGLE_REMOVE_DELEGATES_WITH_BOOKING = 'TOGGLE_REMOVE_DELEGATES_WITH_BOOKING';
export const BOOKING_STATS_REFRESHED              = 'BOOKING_STATS_REFRESHED';
export const SELECT_DELEGATE_FOR_DELETION         = 'SELECT_DELEGATE_FOR_DELETION';
export const HIDE_DELETE_DELEGATE_OVERLAY         = 'HIDE_DELETE_DELEGATE_OVERLAY';
export const UPDATE_OFFSET                        = 'UPDATE_OFFSET';
export const RESET_OFFSET                         = 'RESET_OFFSET';
export const ENROLLING_DELEGATES_STATUS_UPDATED   = 'ENROLLING_DELEGATES_STATUS_UPDATED';

export function hideDeleteDelegateOvelray() {

    return {
        type: HIDE_DELETE_DELEGATE_OVERLAY
    }
}

export function updateOffset() {

    return {
        type: UPDATE_OFFSET
    }
}

export function hideEnrollUserOverlay() {

    return {
        type: HIDE_ENROLL_USER_OVERLAY
    }
}

export function selectDelegateForDeletion(delegate) {

    return {
        type: SELECT_DELEGATE_FOR_DELETION,
        delegate
    }
}

export function deleteTransaction(bookingId, deleteDelegates) {

    return (dispatch) => {

        function bookingDeleted() {

            dispatch(hideDeleteTransactionOverlay());
            dispatch(refreshBookings());
            dispatch(refreshStats());
            notifier.addNotification({ message: 'Transaction deleted successfully', level: 'success' });
        }

        bookingRepo.remove(bookingId, { delete_delegates: deleteDelegates })
            .then(bookingDeleted);
    }
}

export function enrollUser(bookingId) {

    return (dispatch) => {

        function bookingEnrolled() {

            dispatch(enrollingDelegatesStatusUpdated(false));
            dispatch(hideEnrollUserOverlay());
            dispatch(refreshBookings());
            dispatch(refreshStats());
            notifier.addNotification({ message: 'Users are successfully enrolled for this booking', level: 'success' });
        }

        function failure(response) {

            dispatch(enrollingDelegatesStatusUpdated(false));

            notifier.addNotification({
                message: response.data.errors.delegates,
                level: 'error'
            })
        }

        dispatch(enrollingDelegatesStatusUpdated(true));

        return bookingRepo.enrollDelegate({ booking_id: bookingId })
            .then(bookingEnrolled, failure);
    }
}

export function enrollingDelegatesStatusUpdated(isEnrolling) {

    return {
        type: ENROLLING_DELEGATES_STATUS_UPDATED,
        isEnrolling
    }
}

export function removeDelegatesCheckboxChanged() {

    return {
        type: TOGGLE_REMOVE_DELEGATES_WITH_BOOKING
    }
}

export function hideDeleteTransactionOverlay() {

    return {
        type: HIDE_DELETE_BOOKING_OVERLAY
    };
}

export function showDeleteTransactionOverlay(booking) {

    return {
        type: SHOW_DELETE_BOOKING_OVERLAY,
        booking
    };
}

export function showEnrollUserOverlay(booking) {

    return {
        type: SHOW_ENROLL_USER_OVERLAY,
        booking
    };
}

export function filterByReference(referenceCode) {

    return {
        type: FILTER_BOOKINGS_BY_REFERENCE,
        referenceCode
    };
}

export function hideBookingDetails() {

    return {
        type: HIDE_BOOKING_DETAILS
    };
}

export function showBookingDetails(booking) {

    return {
        type: SHOW_BOOKING_DETAILS,
        booking
    };
}

export function updateBooking(booking) {

    return (dispatch) => {

        function updateSuccess(response) {

            dispatch(bookingUpdated(response.data.data));
            notifier.addNotification({ message: 'Booking updated successfully', level: 'success' });
        }

        dispatch(bookingUpdated(booking));

        bookingRepo.update(booking)
            .then(updateSuccess);
    };
}

export function bookingUpdated(booking) {

    return {
        type: BOOKING_UPDATED,
        booking
    }
}

export function loadMoreBookings() {

    return (dispatch, getState) => {

        function getSuccess(response) {

            let bookingList = getState().bookingList.bookings;
            dispatch(bookingsRefreshed(bookingList.concat(response.data.data)));
            dispatch(updateOffset());
        }

        let params = {
            offset: getState().bookingList.offset,
            limit: getState().bookingList.limit
        }

        if(getState().bookingList.referenceFilter != '') {
            params = {
                ...params,
                event_reference: getState().bookingList.referenceFilter
            }
        }

        bookingRepo.getAll(params).then(getSuccess);
    };
}

export function refreshBookings() {

    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(bookingsRefreshed(response.data.data));
            dispatch(updateOffset());
        }

        dispatch(resetoffset());
        let params = {
            offset: 0,
            limit: getState().bookingList.limit
        }

        if(getState().bookingList.referenceFilter != '') {
            params = {
                ...params,
                event_reference: getState().bookingList.referenceFilter
            }
        }

        bookingRepo.getAll(params).then(getSuccess);
    };
}

export function refreshStats() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(statsRefreshed(response.data.data));
        }

        bookingRepo.getStats()
            .then(getSuccess);
    };
}

export function statsRefreshed(stats) {

    return {
        type: BOOKING_STATS_REFRESHED,
        stats
    };
}

export function bookingsRefreshed(bookings) {

    return {
        type: BOOKINGS_REFRESHED,
        bookings
    };
}

export function resetoffset() {

    return {
        type: RESET_OFFSET,
    }
}


// WEBPACK FOOTER //
// ./actions/bookingList.js